__webpack_require__.p = "/programaseducacionais/admin/";